import { combineReducers } from 'redux';
import type { PriceOfStayState } from 'Store/price-remote/price-of-stay/priceOfStay.reducer';
import { priceOfStayReducer } from 'Store/price-remote/price-of-stay/priceOfStay.reducer';
import type { AllInclusiveServicesState } from 'Store/price-remote/all-inclusive-services/allInclusiveServices.reducer';
import { allInclusiveServicesReducer } from 'Store/price-remote/all-inclusive-services/allInclusiveServices.reducer';
export type PriceRemoteState = {
  priceOfStay: PriceOfStayState;
  allInclusiveServices: AllInclusiveServicesState;
};
export const priceRemoteReducer = combineReducers({
  allInclusiveServices: allInclusiveServicesReducer,
  priceOfStay: priceOfStayReducer,
});
